import { removeAllHighlights, tidyEditor } from "../components/MonacoEditorHelper";
import { saveUserData } from "../core/code/saver";
import { CODE_EDITOR, EDITOR_VIEW_NAME } from "../core/constants";
import { getComponentData, getViewData, setViewData } from "../core/views";
import { getAppCfg } from "../core/app-cfg";
import { isCloudProjectId } from "../core/project/projectid";
import { CLOUD_STATE } from "../features/cloudstorage/cloud";
import { executeUserCode } from "./coderunner";
import { evaluateProject, evaluateResult, isWaitingForSuccessEvent } from "./evaluate";
import { logGamificationEvent } from "./gamification/events";
import { requestFinish } from "./globals";

export const executeCodeRequested = async () => {
  const editorState = getViewData(EDITOR_VIEW_NAME);
  if (editorState.data.executionRequested) {
    return;
  }

  // Nur bei Shared-Link (Cloud-Projekt-ID): warten bis loadDataFromCloud fertig ist.
  // Kein globaler Guard fuer eingeloggte User: `cloudState.loaded` wird nicht zuverlaessig
  // gesetzt (z. B. Login ohne Reload, Navigation) und wuerde Start dauerhaft blockieren.
  try {
    const projectId = getAppCfg().projectId;
    if (projectId && isCloudProjectId(projectId)) {
      const cloudState = getComponentData(CLOUD_STATE) as any;
      if (!cloudState?.loaded) {
        console.log("[executeCodeRequested] blocked until cloud loaded (cloud project id)");
        return;
      }
    }
  } catch {
    // Wenn Cloud-Detektion fehlschlägt, altes Verhalten beibehalten.
  }


  await saveUserData();
  const preparedExecutionCode = await executeUserCode(editorState, true);

  const newState = { ...editorState };
  newState.data = {
    ...editorState.data,
    executionRequested: true,
    executionCode: preparedExecutionCode,
    errors: [],
    editorDirty: false,
    time: Date.now(),
    rightTab: 'app' // Beim Starten immer zu "Ausgabe" wechseln (gewollt)
  }
  removeAllHighlights();
  setViewData(EDITOR_VIEW_NAME, newState);
  runPostEvaluation(editorState);
}

const runPostEvaluation = (newState: any) => {
  setTimeout(() => {
    const editorState = getViewData(EDITOR_VIEW_NAME);
    const codeEditorState = getComponentData(CODE_EDITOR)
    const newState2 = { ...newState };
    const finished = evaluateProject(newState2.project, newState2.data.projectProgress);
    const waitForSuccessEvent = isWaitingForSuccessEvent(newState2.project, newState2.data.projectProgress);
    const gotErrors = editorState.data.errors && editorState.data.errors.length > 0;
    let projectProgress = newState2.data.projectProgress;
    let projectError = newState2.data.projectError;
    let errorCounter = newState2.data.errorCounter;
    if (finished && !gotErrors && newState2.project.eval) {
      requestFinish();
    } else if (newState2.project.subTasks && codeEditorState.dirty) {
      if (finished && !gotErrors) {
        projectError = undefined
        errorCounter = undefined;
        if (projectProgress === undefined) {
          projectProgress = 1;
          projectProgress = runNextEvaluation(newState2, projectProgress)
        } else {
          projectProgress++;
          projectProgress = runNextEvaluation(newState2, projectProgress)
        }
        if (projectProgress >= newState2.project.subTasks.length) {
          requestFinish();
        }
      } else {
        projectError = projectProgress === undefined ? 1 : projectProgress + 1;
        errorCounter = errorCounter === undefined ? 1 : errorCounter + 1;
      }
      tidyEditor();
    }
    newState2.data = {
      ...editorState.data,
      projectProgress,
      projectError,
      errorCounter,
      executionRequested: false,
      waitForSuccessEvent: waitForSuccessEvent ? true : undefined,
      rightTab: editorState.data?.rightTab // Explizit erhalten, damit Chat-Tab nicht verloren geht
    };

    setViewData(EDITOR_VIEW_NAME, newState2);
    if (!errorCounter) {
      logGamificationEvent("ProjectExecuted", "Projekt ausgeführt", "Projekt wurde erfolgreich ausgeführt");
    } else {
      logGamificationEvent("ErrorOccured", "Fehler aufgetreten", "Fehler beim Ausführen des Projekts");
    }
  }, 1500);
}

const runNextEvaluation = (newState: any, projectProgress: number) => {

  let nextProgress = projectProgress;
  let nextFinished = true;
  while (nextFinished === true && nextProgress < newState.project.subTasks.length) {

    nextFinished = evaluateResult(newState.project.subTasks[nextProgress].eval);
    if (nextFinished) {
      nextProgress++;
    }
  }
  return nextProgress;
}

export const forceEvaluationGreen = () => {
  const editorState = getViewData(EDITOR_VIEW_NAME);
  const newState = { ...editorState };
  newState.data = {
    ...editorState.data,
    projectProgress: newState.project?.subTasks ? newState.project.subTasks.length : undefined,
    projectError: undefined,
    errorCounter: undefined,
    waitForSuccessEvent: undefined,
    rightTab: editorState.data?.rightTab // Explizit erhalten, damit Chat-Tab nicht verloren geht
  };
  setViewData(EDITOR_VIEW_NAME, newState);
}

export const executeTerminalFrameCode = (code: string) => {
  const editorState = getViewData(EDITOR_VIEW_NAME);
  if (editorState.data.executionRequested) {
    return;
  }

  const preparedExecutionCode = code;

  const newState = { ...editorState };
  newState.data = {
    ...editorState.data,
    executionRequested: true,
    executionCode: preparedExecutionCode,
    errors: [],
    editorDirty: false,
    rightTab: editorState.data?.rightTab // Explizit erhalten, damit Chat-Tab nicht verloren geht
  }
  setViewData(EDITOR_VIEW_NAME, newState);
}




